import { NgModule } from "@angular/core";
import { DecodeHtmlEntities } from "./decode-html-entities.Pipe";
export var DecodeHtmlEntitiesModule = (function () {
    function DecodeHtmlEntitiesModule() {
    }
    DecodeHtmlEntitiesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DecodeHtmlEntities],
                    exports: [DecodeHtmlEntities]
                },] },
    ];
    /** @nocollapse */
    DecodeHtmlEntitiesModule.ctorParameters = function () { return []; };
    return DecodeHtmlEntitiesModule;
}());
//# sourceMappingURL=decode.module.js.map